import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateBrokenConnection = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 227,
	height: 208,
	viewBox: "0 0 227 208",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M117.358 207.396C174.041 207.396 219.991 161.446 219.991 104.763C219.991 48.0806 174.041 2.13037 117.358 2.13037C60.6758 2.13037 14.7256 48.0806 14.7256 104.763C14.7256 161.446 60.6758 207.396 117.358 207.396Z",
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5356 52.4335L3.3698 63.5993C2.59727 64.3719 1.34771 64.3719 0.579403 63.5993C-0.188906 62.8268 -0.193128 61.5772 0.579403 60.8089L11.7452 49.6431C12.5178 48.8706 13.7673 48.8706 14.5356 49.6431C15.3082 50.4157 15.3082 51.6652 14.5356 52.4335Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5356 63.5952C13.7631 64.3677 12.5135 64.3677 11.7452 63.5952L0.579398 52.4294C-0.193133 51.6568 -0.193133 50.4073 0.579398 49.639C1.35193 48.8664 2.60149 48.8664 3.3698 49.639L14.5356 60.8048C15.3081 61.5773 15.3081 62.8269 14.5356 63.5952Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.358 180.522C97.9521 180.522 78.5417 173.134 63.7665 158.359C34.2162 128.808 34.2162 80.7257 63.7665 51.1711C93.3169 21.6207 141.4 21.6207 170.95 51.1711C200.5 80.7215 200.5 128.804 170.95 158.359C156.175 173.134 136.764 180.522 117.358 180.522ZM68.4524 64.7938C48.1639 89.5781 49.5781 126.309 72.6992 149.426C85.009 161.736 101.186 167.895 117.358 167.895C131.555 167.895 145.744 163.154 157.331 153.669L68.4524 64.7896V64.7938ZM77.385 55.8612L166.264 144.74C186.553 119.956 185.138 83.2248 162.017 60.108C138.896 36.9911 102.169 35.5769 77.385 55.8612Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.768 2.50183L213.553 33.9688C215.411 37.2531 213.038 41.3226 209.264 41.3226H174.12C170.368 41.3226 167.995 37.2995 169.806 34.0152L187.165 2.54826C189.026 -0.828923 193.873 -0.85425 195.768 2.50183Z",
			fill: "#6BA6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M191.361 28.4093C190.221 28.4093 189.297 27.4848 189.297 26.345V12.5196C189.297 11.3798 190.221 10.4553 191.361 10.4553C192.501 10.4553 193.425 11.3798 193.425 12.5196V26.345C193.425 27.4848 192.501 28.4093 191.361 28.4093Z",
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M191.365 35.3663C190.816 35.3663 190.285 35.1468 189.905 34.7584C189.807 34.6613 189.723 34.5558 189.647 34.4503C189.571 34.3363 189.508 34.2181 189.457 34.0914C189.406 33.9648 189.36 33.8381 189.339 33.7073C189.318 33.5764 189.301 33.4371 189.301 33.302C189.301 33.1669 189.314 33.0318 189.339 32.8967C189.364 32.7701 189.411 32.6392 189.457 32.5126C189.508 32.3944 189.571 32.272 189.647 32.158C189.723 32.044 189.812 31.9385 189.905 31.8414C190.669 31.0773 192.053 31.0688 192.817 31.8414C192.919 31.9342 192.999 32.044 193.075 32.158C193.151 32.272 193.214 32.3902 193.265 32.5126C193.316 32.6392 193.358 32.7701 193.383 32.8967C193.408 33.0276 193.421 33.1669 193.421 33.302C193.421 33.4371 193.408 33.5722 193.383 33.7073C193.358 33.8424 193.311 33.9648 193.265 34.0914C193.214 34.2181 193.151 34.3363 193.075 34.4503C192.999 34.5558 192.919 34.6655 192.817 34.7584C192.437 35.1426 191.906 35.3663 191.365 35.3663Z",
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M146.733 138.496C130.085 140.517 115.95 126.394 117.958 109.744C118.446 105.693 122.127 102.804 126.178 103.293C130.229 103.782 133.118 107.462 132.629 111.513C131.769 118.644 137.823 124.692 144.952 123.826L186.089 118.832C191.688 118.153 196.099 113.738 196.774 108.139C197.726 100.248 191.027 93.5543 183.136 94.5122L179.042 95.0093C174.991 95.5011 171.309 92.6159 170.817 88.5649C170.325 84.514 173.21 80.8313 177.261 80.3395L181.356 79.8425C198.764 77.729 213.545 92.4976 211.445 109.908C209.955 122.262 200.223 132.002 187.87 133.502L146.733 138.496Z",
			fill: "#152A61",
			stroke: "#152A61",
			strokeWidth: 1.38,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0147 68.8647C95.2559 64.685 111.116 76.8402 111.302 93.6096C111.347 97.69 108.075 101.034 103.994 101.08C99.9141 101.125 96.5698 97.8538 96.5245 93.7736C96.445 86.592 89.6528 81.3864 82.6974 83.1765L42.5665 93.5048C37.1048 94.9105 33.3089 99.8633 33.3713 105.503C33.4593 113.45 40.9754 119.211 48.6726 117.23L52.6666 116.202C56.6185 115.185 60.6474 117.564 61.6644 121.516C62.6815 125.468 60.3018 129.496 56.3499 130.513L52.356 131.541C35.3728 135.911 18.7889 123.201 18.5948 105.666C18.4572 93.2232 26.833 82.2944 38.8838 79.193L79.0147 68.8647Z",
			fill: "#152A61"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0147 68.8647L78.8427 68.1964L78.8427 68.1964L79.0147 68.8647ZM111.302 93.6096L111.992 93.602L111.992 93.602L111.302 93.6096ZM103.994 101.08L104.002 101.77L104.002 101.77L103.994 101.08ZM96.5245 93.7736L95.8345 93.7813L95.8345 93.7813L96.5245 93.7736ZM82.6974 83.1765L82.5254 82.5082L82.5254 82.5082L82.6974 83.1765ZM42.5665 93.5048L42.3946 92.8366L42.3946 92.8366L42.5665 93.5048ZM33.3713 105.503L34.0613 105.495L33.3713 105.503ZM48.6726 117.23L48.5007 116.561L48.5007 116.561L48.6726 117.23ZM52.6666 116.202L52.8385 116.87L52.8385 116.87L52.6666 116.202ZM61.6644 121.516L62.3327 121.344L62.3327 121.344L61.6644 121.516ZM56.3499 130.513L56.5218 131.181L56.5219 131.181L56.3499 130.513ZM52.356 131.541L52.184 130.872L52.184 130.872L52.356 131.541ZM18.5948 105.666L17.9048 105.674L17.9048 105.674L18.5948 105.666ZM38.8838 79.193L39.0558 79.8613L39.0558 79.8613L38.8838 79.193ZM79.0147 68.8647L79.1866 69.5329C94.9943 65.4648 110.431 77.2956 110.612 93.6172L111.302 93.6096L111.992 93.602C111.801 76.3849 95.5175 63.9052 78.8427 68.1964L79.0147 68.8647ZM111.302 93.6096L110.612 93.6172C110.653 97.3165 107.686 100.349 103.987 100.39L103.994 101.08L104.002 101.77C108.463 101.72 112.041 98.0636 111.992 93.602L111.302 93.6096ZM103.994 101.08L103.987 100.39C100.287 100.43 97.2555 97.4651 97.2144 93.766L96.5245 93.7736L95.8345 93.7813C95.8841 98.2426 99.5407 101.819 104.002 101.77L103.994 101.08ZM96.5245 93.7736L97.2144 93.766C97.13 86.1367 89.9144 80.6066 82.5254 82.5082L82.6974 83.1765L82.8694 83.8447C89.3912 82.1662 95.76 87.0473 95.8345 93.7813L96.5245 93.7736ZM82.6974 83.1765L82.5254 82.5082L42.3946 92.8366L42.5665 93.5048L42.7385 94.1731L82.8694 83.8447L82.6974 83.1765ZM42.5665 93.5048L42.3946 92.8366C36.6252 94.3215 32.6154 99.5532 32.6814 105.51L33.3713 105.503L34.0613 105.495C34.0024 100.173 37.5844 95.4996 42.7385 94.1731L42.5665 93.5048ZM33.3713 105.503L32.6814 105.51C32.7743 113.906 40.7138 119.99 48.8446 117.898L48.6726 117.23L48.5007 116.561C41.237 118.431 34.1443 112.995 34.0613 105.495L33.3713 105.503ZM48.6726 117.23L48.8446 117.898L52.8385 116.87L52.6666 116.202L52.4946 115.534L48.5007 116.561L48.6726 117.23ZM52.6666 116.202L52.8385 116.87C56.4215 115.948 60.0742 118.105 60.9962 121.688L61.6644 121.516L62.3327 121.344C61.2206 117.023 56.8155 114.422 52.4946 115.534L52.6666 116.202ZM61.6644 121.516L60.9962 121.688C61.9182 125.271 59.7608 128.923 56.1779 129.845L56.3499 130.513L56.5219 131.181C60.8427 130.069 63.4447 125.665 62.3327 121.344L61.6644 121.516ZM56.3499 130.513L56.178 129.845L52.184 130.872L52.356 131.541L52.5279 132.209L56.5218 131.181L56.3499 130.513ZM52.356 131.541L52.184 130.872C35.6344 135.132 19.4739 122.746 19.2848 105.658L18.5948 105.666L17.9048 105.674C18.1039 123.657 35.1112 136.691 52.5279 132.209L52.356 131.541ZM18.5948 105.666L19.2848 105.658C19.1507 93.5332 27.3126 82.8834 39.0558 79.8613L38.8838 79.193L38.7118 78.5248C26.3533 81.7053 17.7637 92.9132 17.9048 105.674L18.5948 105.666ZM38.8838 79.193L39.0558 79.8613L79.1867 69.5329L79.0147 68.8647L78.8427 68.1964L38.7118 78.5248L38.8838 79.193Z",
			fill: "#152A61"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 128.874,
			y1: 65.5732,
			x2: 120.455,
			y2: 82.1633,
			stroke: "#152A61",
			strokeWidth: 8.28,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 145.146,
			y1: 73.6243,
			x2: 128.445,
			y2: 89.7042,
			stroke: "#152A61",
			strokeWidth: 8.28,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 135.873,
			y1: 98.078,
			x2: 153.461,
			y2: 90.8058,
			stroke: "#152A61",
			strokeWidth: 8.28,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 103.151,
			y1: 142.898,
			x2: 110.947,
			y2: 126.006,
			stroke: "#152A61",
			strokeWidth: 8.28,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 86.5906,
			y1: 135.457,
			x2: 102.682,
			y2: 118.768,
			stroke: "#152A61",
			strokeWidth: 8.28,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 94.9479,
			y1: 110.675,
			x2: 77.6433,
			y2: 118.597,
			stroke: "#152A61",
			strokeWidth: 8.28,
			strokeLinecap: "round"
		})
	]
});
export default SvgEmptyStateBrokenConnection;
